











































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import Screenfull from '@/components/Screenfull/index.vue'
import { organization } from '@/api/organization';

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
  }
})
export default class extends Vue {
  private selectType: any = ''
  private organizationName: string = ''

  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  get avatar() {
    return UserModule.avatar
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    await UserModule.LogOut()
    if (this.organizationName.indexOf('上海勘察') !== -1) {
      this.$router.push(`/login?sgidi&redirect=${this.$route.fullPath}`)
    } else {
      this.$router.push(`/login?redirect=${this.$route.fullPath.replace('?sgidi' , '')}`)
    }
  }

  private created() {
    this.selectType = this.$Cookies.get('organizationId') === '' ? '' : Number(this.$Cookies.get('organizationId'))
    this.organizationName = this.$Cookies.get('organizationName')
  }

  private updataPassword() {
    this.$router.push({
      path: '/updatePassword/index'
    })
  }
}
